<ng-container *ngIf="isClickable; else nonClickableItem">
  <a
    class="medium-type font-body-1 link-hover underline-hover {{ customClasses }} font-label-medium"
    tabindex="0"
    [attr.data-testid]="'summary-clickable-item-' + type"
    (click)="clickAction.emit(type)"
    (keydown.enter)="clickAction.emit(type)"
  >
    <ng-container [ngTemplateOutlet]="content" />
  </a>
</ng-container>
<ng-template #nonClickableItem>
  <span
    class="medium-type font-body-1 {{ customClasses }} font-label-medium"
    tabindex="0"
    [attr.data-testid]="'summary-item-' + type"
  >
    <ng-container [ngTemplateOutlet]="content" />
  </span>
</ng-template>
<ng-template #content>
  <ng-content select=".content" />
</ng-template>
